<label class="upload-photo">
    <ng-content select="[upload-picture-button]"></ng-content>
    <input hidden="hidden" type="file" accept="image/*" (change)="onFileChange($event.target['files'])" multiple="false">
</label>

<span (click)="activateCamera()" class="activate-camera">
    <ng-content select="[activate-camera-button]">
    </ng-content>
</span>

<div>
    <video *ngIf="cameraActive" #video class="image-container" autoplay></video>
</div>

<div *ngIf="cameraActive" (click)="capture()">
    <ng-content select="[take-photo-button]">
    </ng-content>
</div>

<div *ngIf="!cameraActive" class="image-container">
    <ng-content select="[image-container]">
    </ng-content>
</div>

<div *ngIf="errorMessage" class="error">{{errorMessage}}</div>

<!-- hidden canvas container -->
<canvas #canvas id="canvas" class="image-container" hidden="hidden"></canvas>